var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTelescopeColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 12,
    cy: 22,
    rx: 9,
    ry: 1,
    fill: "#434959"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 22H16.3154L12 14.0879L7.68457 22H5.40625L11.1221 11.5215L12 12L12.8779 11.5215L18.5938 22Z",
    fill: "url(#paint0_linear_2770_996)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9794 7.49951L5.71182 10.5002L3.97977 11.5002L2.24734 8.49951L3.9794 7.49951Z",
    fill: "url(#paint1_linear_2770_996)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7499 2.06006L21.2499 6.39019L5.18274 15.6666C4.94359 15.8046 4.6378 15.7227 4.49973 15.4835L2.49973 12.0194C2.36165 11.7803 2.44359 11.4745 2.68274 11.3364L18.7499 2.06006Z",
    fill: "url(#paint2_linear_2770_996)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8165 1.44381C18.0556 1.30576 18.3614 1.38766 18.4995 1.62677L21.5002 6.8225C21.6383 7.06165 21.5564 7.36749 21.3172 7.50557L20.6829 7.87178C20.4438 8.00984 20.1381 7.92793 20 7.68883L16.9992 2.4931C16.8611 2.25395 16.943 1.94811 17.1822 1.81002L17.8165 1.44381Z",
    fill: "#FAAF46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11Z",
    fill: "url(#paint3_linear_2770_996)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12C12.5523 12 13 11.5523 13 11ZM15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z",
    fill: "url(#paint4_linear_2770_996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2770_996",
    x1: 7,
    y1: 12,
    x2: 13.085,
    y2: 21.1068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969423,
    stopColor: "#1852FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2770_996",
    x1: 3.00003,
    y1: 10,
    x2: 5.00003,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485577,
    stopColor: "#1852FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2770_996",
    x1: 5.5,
    y1: 9.6699,
    x2: 8,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1852FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312917,
    stopColor: "#4D79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73143,
    stopColor: "#003AE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924671,
    stopColor: "#4D79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1852FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2770_996",
    x1: 11,
    y1: 10,
    x2: 13,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1852FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2770_996",
    x1: 10.5,
    y1: 8.40192,
    x2: 13.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99E20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTelescopeColored);
export default __webpack_public_path__ + "static/media/ic_action_telescope_colored.3219cce2bb14216b1521f7bdafa542d3.svg";
export { ForwardRef as ReactComponent };